import { allowOnlyNumbers } from '@src/shared';

export const getPassportSerries = (passportSeriesAndNumber: string) => {
  return allowOnlyNumbers(passportSeriesAndNumber)?.substring(0, 4);
};
